module.exports = __webpack_public_path__ + "img/logo.a7f2c1b3.png";